import React, { PropTypes } from 'react';
import Markdown from '../../../shared/Markdown'
import CSSModules from 'react-css-modules'

const PersonDetailBio = ({ person }) => (
    !!person.PerMarkdown ? (
        <div className="detail-section-content">
            <Markdown source={ person.PerMarkdown } />
        </div>
    ) : <div></div>
);

PersonDetailBio.propTypes = {
    person: PropTypes.object.isRequired,
};

export default CSSModules(PersonDetailBio);


// WEBPACK FOOTER //
// ./app/components/Person/Detail/Bio/Bio.jsx